module.exports = __webpack_public_path__ + "img/ic_success_banner.ee795ac.svg";